import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Varicose Veins Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Endovenous Laser Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Minimally Invasive Treatment"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Radiology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Ultrasound Guided Procedures"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Vein Care"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MD - Vascular Medicine",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Sclerotherapy Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Varicose Veins Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for comprehensive varicose veins treatment with advanced minimally invasive techniques and rapid recovery.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const VaricoseVeinsTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Comprehensive Varicose Veins Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Advanced Minimally Invasive Treatments with 98% Success Rate. Walk-in, Walk-out Procedures with Immediate Relief.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              View Treatment Options
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>30 min</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Average Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1 in 3</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Adults Affected</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>24-48</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Return to Work</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "causes", label: "Causes", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "recovery", label: "Recovery", icon: "🔄" },
              { id: "prevention", label: "Prevention", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Varicose Veins Treatment</span>
            </h2>
          </div>

          {/* What are Varicose Veins */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Varicose Veins
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Varicose veins are enlarged, twisted veins that typically appear blue or dark purple and occur 
                when faulty valves in the veins allow blood to flow in the wrong direction or to pool. They 
                most commonly affect the legs and feet because standing and walking upright increases pressure 
                in the veins of the lower body.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Vein Anatomy</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Healthy veins have one-way valves that prevent blood from flowing backward. 
                      When these valves fail, blood pools in the veins, causing them to stretch and enlarge.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Disease Progression</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Varicose veins typically worsen over time without treatment. Early intervention 
                      can prevent complications like skin changes, ulcers, and deep vein thrombosis.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Symptoms */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Symptoms Guide
            </h3>

            <div className="row">
              {[
                {
                  title: "Visible Veins", 
                  description: "Dark purple or blue veins that are clearly visible through the skin",
                  details: "Most common symptom, often described as rope-like or bulging"
                },
                {
                  title: "Leg Pain & Heaviness", 
                  description: "Aching, heavy feeling in legs that worsens throughout the day",
                  details: "Especially noticeable after prolonged standing or sitting"
                },
                {
                  title: "Swelling & Inflammation", 
                  description: "Swelling in feet and ankles, particularly in the evening",
                  details: "Caused by fluid accumulation due to poor circulation"
                },
                {
                  title: "Itching & Skin Changes", 
                  description: "Itchy skin around affected veins and potential skin discoloration",
                  details: "May indicate developing venous eczema or skin damage"
                },
                {
                  title: "Muscle Cramping", 
                  description: "Painful muscle cramps, especially at night during sleep",
                  details: "Often described as 'charley horses' in the calves"
                },
                {
                  title: "Restless Legs", 
                  description: "Uncomfortable sensations creating urge to move legs",
                  details: "Particularly bothersome when trying to rest or sleep"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Types of Venous Disorders */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Venous Disorders
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Varicose Veins",
                    description: "Large, swollen veins that rope-like and bulge above the skin surface",
                    treatment: "EVLT, RFA, Sclerotherapy, Venaseal, Microphlebectomy"
                  },
                  {
                    type: "Spider Veins",
                    description: "Smaller, web-like red or blue veins closer to the skin surface",
                    treatment: "Sclerotherapy, Laser therapy, Cosmetic treatments"
                  },
                  {
                    type: "Reticular Veins",
                    description: "Blue or green veins that are larger than spider veins but don't bulge",
                    treatment: "Sclerotherapy, Surface laser treatment"
                  },
                  {
                    type: "Chronic Venous Insufficiency",
                    description: "Advanced condition where veins cannot pump blood back to the heart",
                    treatment: "Combination therapy, Compression stockings, Lifestyle changes"
                  },
                  {
                    type: "Deep Vein Thrombosis",
                    description: "Blood clots in deep veins, a serious medical condition",
                    treatment: "Blood thinners, Compression, Medical monitoring"
                  },
                  {
                    type: "Venous Ulcers",
                    description: "Open sores that develop when veins don't heal properly",
                    treatment: "Wound care, Compression therapy, Vein treatment"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Weak or damaged vein valves and walls</li>
                      <li style={{ marginBottom: "10px" }}>Increased pressure in leg veins from standing</li>
                      <li style={{ marginBottom: "10px" }}>Age-related wear and tear on vein valves</li>
                      <li style={{ marginBottom: "10px" }}>Hormonal changes affecting vein elasticity</li>
                      <li>Genetic predisposition and family history</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age (risk increases with aging)</li>
                      <li style={{ marginBottom: "10px" }}>Female gender (hormonal factors)</li>
                      <li style={{ marginBottom: "10px" }}>Pregnancy (increased blood volume and pressure)</li>
                      <li style={{ marginBottom: "10px" }}>Obesity (extra pressure on veins)</li>
                      <li>Family history of varicose veins</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Minimally Invasive Procedures
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Modern varicose veins treatment has evolved to include highly effective minimally invasive 
                    procedures that offer excellent results with minimal downtime. These walk-in, walk-out 
                    treatments are performed under local anesthesia and allow immediate return to normal activities.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Procedures:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Endovenous Laser Treatment (EVLT)</li>
                          <li style={{ marginBottom: "8px" }}>Radiofrequency Ablation (RFA)</li>
                          <li style={{ marginBottom: "8px" }}>Venaseal™ Closure System</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Ultrasound-guided Sclerotherapy</li>
                          <li style={{ marginBottom: "8px" }}>Microphlebectomy</li>
                          <li style={{ marginBottom: "8px" }}>ClariVein® OC</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Benefits:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>No general anesthesia required</li>
                      <li style={{ marginBottom: "8px" }}>Minimal to no scarring</li>
                      <li style={{ marginBottom: "8px" }}>Immediate return to normal activities</li>
                      <li>98% success rate with single treatment</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Conservative & Surgical Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Management:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Compression stockings therapy</li>
                      <li style={{ marginBottom: "10px" }}>Lifestyle modifications and exercise</li>
                      <li style={{ marginBottom: "10px" }}>Elevation and leg movement routines</li>
                      <li style={{ marginBottom: "10px" }}>Weight management programs</li>
                      <li>Medications for symptom relief</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Traditional Surgical Options:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Vein stripping and ligation</li>
                      <li style={{ marginBottom: "10px" }}>Ambulatory phlebectomy</li>
                      <li style={{ marginBottom: "10px" }}>Endoscopic vein surgery</li>
                      <li style={{ marginBottom: "10px" }}>Bypass surgery for severe cases</li>
                      <li>Reserved for complex or recurrent cases</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Procedure Selection:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Based on vein size and location</li>
                      <li style={{ marginBottom: "10px" }}>Patient symptoms and lifestyle factors</li>
                      <li>Ultrasound mapping and diagnostic findings</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Comparison */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment Options Comparison
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "EVLT",
                    title: "Endovenous Laser",
                    activities: ["30-60 minutes", "Local anesthesia", "98% success", "24hr recovery"]
                  },
                  {
                    period: "RFA",
                    title: "Radiofrequency",
                    activities: ["45 minutes", "Local anesthesia", "97% success", "24hr recovery"]
                  },
                  {
                    period: "VenaSeal",
                    title: "Venaseal System",
                    activities: ["30 minutes", "No anesthesia", "99% success", "Immediate recovery"]
                  },
                  {
                    period: "Sclero",
                    title: "Sclerotherapy",
                    activities: ["15-30 minutes", "No anesthesia", "90% success", "No downtime"]
                  }
                ].map((treatment, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {treatment.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {treatment.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {treatment.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recovery & Prevention */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Recovery & Prevention Strategies
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-Treatment Recovery</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Walk immediately after procedure</li>
                      <li style={{ marginBottom: "10px" }}>Wear compression stockings as directed</li>
                      <li style={{ marginBottom: "10px" }}>Avoid strenuous exercise for 1-2 weeks</li>
                      <li>Follow-up ultrasound to confirm success</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular exercise and movement</li>
                      <li style={{ marginBottom: "10px" }}>Maintain healthy weight</li>
                      <li style={{ marginBottom: "10px" }}>Elevate legs when resting</li>
                      <li>Avoid prolonged sitting or standing</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Are varicose veins treatments covered by insurance?",
                  answer: "Most insurance plans cover varicose veins treatment when it's medically necessary rather than purely cosmetic. Coverage typically requires documentation of symptoms such as pain, swelling, skin changes, or ulceration. Diagnostic ultrasound is usually covered to determine medical necessity. Cosmetic treatments for spider veins without medical symptoms are generally not covered. We work with patients to verify insurance benefits and provide necessary documentation for pre-authorization. Our insurance specialists can help you understand your coverage and out-of-pocket costs before treatment."
                },
                {
                  question: "How long do the results of varicose veins treatment last?",
                  answer: "Modern minimally invasive treatments for varicose veins provide long-lasting results. The treated veins are permanently closed and absorbed by the body, so they cannot recur. However, it's important to understand that treatment addresses existing problematic veins but doesn't prevent new veins from developing over time. Most patients enjoy significant symptom relief for many years. We recommend ongoing vein health maintenance including regular exercise, weight management, and wearing compression stockings when needed to help prevent new vein issues from developing."
                },
                {
                  question: "Is varicose veins treatment painful?",
                  answer: "Modern varicose veins treatments are designed to be as comfortable as possible. Most procedures are performed under local anesthesia, so you're awake but the treated area is numb. Patients typically report feeling only minor discomfort during the procedure, often describing it as a slight pulling or warming sensation. After the procedure, any discomfort is usually mild and can be managed with over-the-counter pain relievers. Compared to traditional vein stripping surgery, minimally invasive treatments involve significantly less pain and faster recovery. Most patients return to normal activities within 24-48 hours."
                },
                {
                  question: "Can varicose veins return after treatment?",
                  answer: "The specific veins treated during varicose veins procedures are permanently eliminated and cannot return. However, it's possible for new varicose veins to develop over time in different locations, as the underlying tendency for vein issues may still be present. This is why we emphasize comprehensive vein evaluation and treatment of all incompetent veins during the initial procedure. Regular follow-up and maintenance of good vein health through lifestyle measures can significantly reduce the risk of new veins developing. The success rate for modern treatments is 95-98% at 5 years when performed by experienced vascular specialists."
                },
                {
                  question: "What's the difference between spider veins and varicose veins?",
                  answer: "Spider veins and varicose veins are both manifestations of venous insufficiency but differ in size and severity. Spider veins are small, dilated blood vessels near the skin surface, typically red or blue, measuring less than 1mm in diameter. They're primarily a cosmetic concern. Varicose veins are larger, swollen, twisted veins that bulge above the skin surface, typically more than 3mm in diameter. They often cause symptoms like pain, swelling, and heaviness, and can lead to more serious complications if left untreated. While spider veins can be treated with cosmetic procedures, varicose veins usually require medical treatment to relieve symptoms and prevent complications."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready to Say Goodbye to Varicose Veins?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides advanced varicose veins treatments with minimal downtime and maximum results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Vein Screening
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Vascular Care: <strong>080-6541-7705</strong> | Treatment Info: <strong>080-6541-7706</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default VaricoseVeinsTreatment;